
const venues = []

export default venues


// WEBPACK FOOTER //
// ./src/data/venues.js